/**
 * Portal Manta · BackendStatus
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { API } from '../../app-globals.js';

function BackendStatus(){
  const [status,setStatus] = useState({checking:true});
  useEffect(()=>{
    let cancel=false;
    API.ping().then(j=>{
      if(!cancel) setStatus({ok:!!j,info:j,checking:false});
    });
    return ()=>{cancel=true};
  },[]);
  if(status.checking) return(<span style={{fontSize:9.5,color:V.gr,padding:'2px 8px'}}>● checando backend…</span>);
  if(status.ok) return(<span style={{fontSize:9.5,color:V.gn,padding:'2px 8px',background:V.gnb||V.gr+'22',borderRadius:99,fontWeight:600}}>● Backend OK · {status.info?.counts?.lotes||0}L · {status.info?.counts?.sicro_itens||0}SICRO</span>);
  return(<span title={`Backend não disponível em ${API.base} — usando dados embutidos`} style={{fontSize:9.5,color:V.gr,padding:'2px 8px',background:V.g0,borderRadius:99,fontWeight:600}}>● Backend OFF · usando dados embutidos</span>);
}

export { BackendStatus };
export default BackendStatus;
